import React from "react";
import moment from "moment";
import { MILESTONES } from "./ExecutionBlueprintHelpers";

const STEP_DATE_FORMAT = "Do MMM, YY";

// Renders the 11-step milestone timeline inside each client row's accordion
// body. done/current are driven by `filled` (stage_index), same as Strategy
// Canvas's own steps component - `timestamps` is only consulted for display
// (the real label/date for a step), looked up by milestone `key` rather than
// by array position. That's deliberate: whether the backend's `timestamps[]`
// carries all 11 keys or only the ones reached so far is still an open
// question (docs/execution-blueprint/COACH-API.md §5), and a keyed lookup
// gives the right answer either way, where a positional one would not.
const ExecutionBlueprintSteps = ({ filled = 0, timestamps = [] }) => {
  const timestampByKey = new Map(
    (timestamps || []).map((timestamp) => [timestamp.key, timestamp]),
  );

  return (
    <div className="ebm-steps">
      {MILESTONES.map(({ key, label: fallbackLabel }, index) => {
        const stepNumber = index + 1;
        const isDone = stepNumber <= filled;
        const isCurrent = stepNumber === filled;
        const timestamp = timestampByKey.get(key);

        return (
          <div
            className={`ebm-step-row ${isDone ? "done" : ""} ${
              isCurrent ? "current" : ""
            }`}
            key={key}
          >
            <div className="ebm-step-number">Step {stepNumber}</div>
            <div className="ebm-step-icon">
              {isDone ? (
                <img src="/assets/images/true-sucess.svg" alt="" />
              ) : (
                "–"
              )}
            </div>
            <div className="ebm-step-label">
              {/* Our wording wins over the API's `timestamps[].label`: the
                  backend still sends "Synthesis completed", "Critique ready"
                  etc., which are not the words JK wants. Only the date comes
                  from the API. */}
              {fallbackLabel}
            </div>
            <div className="ebm-step-date">
              {isDone && timestamp?.at
                ? moment(timestamp.at).format(STEP_DATE_FORMAT)
                : "-"}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ExecutionBlueprintSteps;
